module.exports = __webpack_public_path__ + "static/img/hover-iocn80.65d7c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn80.png
// module id = 9osf
// module chunks = 0